var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKoa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#151521"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2024 13V21.632L13.9816 17.3333H14.1534L11.3534 20.5227L15.0466 26H13.8442L10.6663 21.2853L10.2024 21.8226V26H9V13H10.2024ZM16.1723 21.7376C16.1723 18.9254 17.9706 17.3595 20.3116 17.3595C22.4661 17.3595 24.3151 18.4708 24.3151 21.5355C24.3151 24.3476 22.5169 25.9135 20.1759 25.9135C18.0214 25.9135 16.1723 24.8022 16.1723 21.7376ZM17.2878 21.738C17.2878 24.7006 18.5767 25.801 20.175 25.801C21.8592 25.801 23.1997 24.2435 23.1997 21.5349C23.1997 18.5723 21.9107 17.4719 20.3125 17.4719C18.6283 17.4719 17.2878 19.0294 17.2878 21.738ZM32.4839 25.8633C30.4529 25.8633 30.5528 24.6677 30.5528 24.6677V24.432C30.2198 25.0382 29.5872 25.9306 27.9391 25.9306C25.9913 25.9306 25.6584 24.6846 25.5585 24.011C25.392 22.8828 25.7916 22.0408 28.7549 21.8388C29.504 21.7714 30.353 21.8051 30.5528 21.8219V19.0267C30.5528 19.0267 30.7359 17.5112 28.8048 17.5112C27.7726 17.5112 26.4908 17.949 26.0746 18.1848L26.008 18.0669C26.2244 17.9659 27.2399 17.3765 29.0212 17.3765C31.4351 17.3765 31.7182 18.4542 31.7182 19.0267V24.6677C31.7182 25.7622 32.4839 25.7286 32.4839 25.7286H33V25.8633H32.4839ZM28.2304 25.8181C29.4785 25.8181 30.4967 24.6717 30.546 23.9872V21.9169C30.3489 21.8998 29.577 21.8313 28.7559 21.934C27.0151 22.1393 26.6702 22.7553 26.7688 24.0044C26.8345 24.8428 27.0808 25.8181 28.2304 25.8181Z",
    fill: "#151521"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKoa);
export default __webpack_public_path__ + "static/media/koa.d327d5eb308b8a5e392ecd0a2cecbed6.svg";
export { ForwardRef as ReactComponent };